import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class DataView extends BaseEntityModel {
  /**
   * @var {string}
   */
  id;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {boolean}
   */
  is_geo;

  /**
   * @var {string}
   */
  extended_id;

  /**
   * @var {string}
   */
  grid_id;

  /**
   * @var {array}
   */
  nav_buttons;

  /**
   * @var {string}
   */
  grid_name;

  /**
   * @var {string}
   */
  parent_grid_name;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.name = model.name || model.text;
    this.is_geo = model.is_geo;
    this.extended_id = model.extended_id;
    this.grid_id = model.grid_id;
    this.nav_buttons = model.nav_buttons;
    this.grid_name = model.grid_name;
    this.parent_grid_name = model.parent_grid_name;
  }
}
